import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["add_item", "template"]
  static values = { index: String }

  add_association(event) {
    event.preventDefault()
    let child_index_name = this.indexValue;
    var content = this.templateTarget.innerHTML.replace(new RegExp(child_index_name,"g"), new Date().valueOf())
    this.add_itemTarget.insertAdjacentHTML('beforebegin', content)
  }

  remove_association(event, answer) {
    event.preventDefault()

    if (!event.detail[0]) {
      // User cancelled
      return
    }

    let item = event.target.closest(".nested-fields")
    item.querySelector("input[name*='_destroy']").value = 1
    item.style.display = 'none'
    this.clearRequired(item)
  }

  clearRequired(item) {
    item.querySelectorAll("input[required]").forEach((node) => {
      node.required = false
    })
    item.querySelectorAll("select[required]").forEach((node) => {
      node.required = false
    })
  }
}
